import type { PlayerResponse } from "@softmax/observatory-client/types";

export type AgentRow = {
  player: PlayerResponse | null;
  id: string | null;
  name: string;
  savedName: string;
  avatarUrl: string | null;
  isDefault: boolean;
};

export function agentRows({
  agents,
  drafts,
  newName,
}: {
  readonly agents: readonly PlayerResponse[];
  readonly drafts: Readonly<Record<string, string>>;
  readonly newName: string;
}): AgentRow[] {
  const rows: AgentRow[] = agents.map((player) => ({
    player,
    id: player.id,
    name: drafts[player.id] ?? player.name,
    savedName: player.name,
    avatarUrl: player.avatar_url ?? null,
    isDefault: player.is_default,
  }));

  if (rows.length === 0) {
    rows.push({
      player: null,
      id: null,
      name: newName,
      savedName: "",
      avatarUrl: null,
      isDefault: true,
    });
  }

  return rows;
}
